//import { VanillaJSCarousel } from "./carousel";

import { setDisplay } from "./common";
import { VanillaJSCarousel } from "./carousel";
import { gphClose } from "./common";
import { gphGif } from "./common";
const gifView = document.getElementById("gifView") as HTMLDivElement;
const btnGif = document.getElementById("btnGif") as HTMLButtonElement;
const carouselView = document.getElementById("carView");
const inGifSearch = document.getElementById("inGifSearch") as HTMLInputElement;
const textContainer = document.getElementById("textContainer");
var elGif = document.getElementById("spCl");
var car: VanillaJSCarousel;
var defaulInput = "Dancing";
var isGiphyLoaded: boolean;
//let car : VanillaJSCarousel;
if (carouselView) {
  if (elGif != null) {
    car = new VanillaJSCarousel(carouselView, defaulInput, elGif);
    elGif.addEventListener("click", function () {
      if (car) {
        //console.log("gif: " + car.getUrl());
        var gifLink =
          "https://media2.giphy.com/media/" + car.getUrl() + "/giphy.gif";
        this.textContent = gifLink;
        inGifSearch.value = "";
        btnGif.style.backgroundImage =
          "url('" +
          gphGif +
          "')" +
          ",linear-gradient(to right, rgb(5, 0, 156), rgb(39,199,254))";
        var event = new Event("change");

        // Dispatch it.
        this.dispatchEvent(event);
        //uploadGif(car.getUrl());
      }
    });
  }
}

btnGif.onclick = function () {
  if (gifView.style.display == "none" || !gifView.style.display) {
    setDisplay(gifView, "flex");
    inGifSearch.focus();
    if (!isGiphyLoaded) {
      loadGifs();
    }
    btnGif.style.backgroundImage =
      "url('" +
      gphClose +
      "')" +
      ",linear-gradient(to right, rgb(5, 0, 156), rgb(39,199,254))";
  } else {
    if (textContainer != null) {
      textContainer.focus();
    }

    setDisplay(gifView, "none");
    btnGif.style.backgroundImage =
      "url('" +
      gphGif +
      "')" +
      ",linear-gradient(to right, rgb(5, 0, 156), rgb(39,199,254))";
  }
};

// function setDisplay(element: HTMLElement, displayType: string){
//     // if(element && !element.style){
//     //     element = document.getElementById(element);
//     // }
//     element.style.display = displayType;
// }

function loadGifs() {
  inGifSearch.addEventListener("input", function () {
    var searchValue = inGifSearch.value.trim();
    if (searchValue === "") {
      if (!car && carouselView) {
        if (elGif == null) {
          return;
        }
        car = new VanillaJSCarousel(carouselView, defaulInput, elGif);
      } else {
        car.searchGiphy(defaulInput);
      }
    } else {
      if (!car && carouselView) {
        if (elGif == null) {
          return;
        }
        car = new VanillaJSCarousel(carouselView, searchValue, elGif);
      } else {
        car.searchGiphy(searchValue);
      }
    }
  });
}
